import React, { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { Button } from './ui/button';
import { siteContent } from '../content/siteContent';

const Header = () => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const { brand, navigation } = siteContent;

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (e, href) => {
    e.preventDefault();
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
      setIsMobileMenuOpen(false);
    }
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isScrolled
          ? 'bg-black/80 backdrop-blur-xl border-b border-[#D22527]/20 shadow-lg shadow-[#D22527]/5'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="flex items-center justify-between h-20">
          <a href="#hero" onClick={(e) => scrollToSection(e, '#hero')} className="flex items-center group">
            <img
              src={brand.logoSrc}
              alt={brand.logoAlt}
              className="h-12 w-12 transition-transform duration-500 group-hover:scale-110 group-hover:rotate-12"
            />
          </a>

          <nav className="hidden md:flex items-center gap-8">
            {navigation.items.map((item, index) => (
              <a
                key={index}
                href={item.href}
                onClick={(e) => scrollToSection(e, item.href)}
                className="text-gray-300 hover:text-white transition-all duration-300 text-sm font-medium relative group"
              >
                {item.label}
                <span className="absolute -bottom-1 left-0 w-0 h-0.5 bg-gradient-to-r from-[#D22527] to-[#88171A] transition-all duration-300 group-hover:w-full"></span>
              </a>
            ))}
          </nav>

          <div className="hidden md:block">
            <Button
              onClick={(e) => scrollToSection(e, '#contact')}
              className="bg-gradient-to-r from-[#D22527] to-[#88171A] text-white hover:shadow-lg hover:shadow-[#D22527]/50 transition-all duration-300 hover:scale-105 border-0"
            >
              {navigation.primaryCta}
            </Button>
          </div>

          <button
            onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
            className="md:hidden text-white p-2 hover:bg-[#D22527]/10 rounded-lg transition-colors duration-300"
          >
            {isMobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
          </button>
        </div>
      </div>

      <div
        className={`md:hidden transition-all duration-500 ease-in-out overflow-hidden ${
          isMobileMenuOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-black/95 backdrop-blur-xl border-t border-[#D22527]/20 px-6 py-6">
          <nav className="flex flex-col gap-4">
            {navigation.items.map((item, index) => (
              <a
                key={index}
                href={item.href}
                onClick={(e) => scrollToSection(e, item.href)}
                className="text-gray-300 hover:text-white transition-colors duration-300 text-base py-2 hover:pl-2"
              >
                {item.label}
              </a>
            ))}
            <Button
              onClick={(e) => scrollToSection(e, '#contact')}
              className="bg-gradient-to-r from-[#D22527] to-[#88171A] text-white hover:shadow-lg hover:shadow-[#D22527]/50 transition-all duration-300 mt-4 border-0"
            >
              {navigation.primaryCta}
            </Button>
          </nav>
        </div>
      </div>
    </header>
  );
};

export default Header;
